// removed by extract-text-webpack-plugin
module.exports = {"wrapper-sidebar":"magazines_2_OFa","show":"magazines_1vtqA","hide":"magazines_M6FLH","ba-subtitle":"magazines_21C99","float-button":"magazines_2y-3w","minimal":"magazines_3qu9w"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Editor/components/Sidebar/styles.scss
// module id = 1057
// module chunks = 1